<!-- Searchbar.vue -->
<template>
    <div class="custom-searchbar" :class="{ 'has-focus': isFocused }">
        <div class="searchbar-input-container">
            <div class="searchbar-search-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M456.69 421.39L362.6 327.3a173.81 173.81 0 0034.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 00327.3 362.6l94.09 94.09a25 25 0 0035.3-35.3zM97.92 222.72a124.8 124.8 0 11124.8 124.8 124.95 124.95 0 01-124.8-124.8z" />
                </svg>
            </div>
            <input ref="inputEl" type="search" :placeholder="placeholder" :value="modelValue" @input="updateValue($event)" @focus="onFocus" @blur="onBlur" class="searchbar-input" />
            <div v-if="modelValue" class="searchbar-clear-icon" @click="clearInput">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm86.63 272L320 342.63l-64-64-64 64L169.37 320l64-64-64-64L192 169.37l64 64 64-64L342.63 192l-64 64z" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Search'
        },
        mode: {
            type: String,
            default: 'ios'
        },
        position: {
            type: String,
            default: 'start'
        },
        autofocus: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isFocused: false
        }
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
            // Ensure focus is maintained after update
            this.$nextTick(() => {
                if (this.isFocused) {
                    this.$refs.inputEl.focus();
                }
            });
        },
        clearInput() {
            this.$emit('update:modelValue', '');
            this.setFocus();
        },
        onFocus() {
            this.isFocused = true;
            this.$emit('focus');
        },
        onBlur() {
            this.isFocused = false;
            this.$emit('blur');
        },
        setFocus() {
            this.$refs.inputEl.focus();
        }
    },
    // Add a watcher to maintain focus when modelValue changes externally
    watch: {
        modelValue() {
            if (this.isFocused) {
                this.$nextTick(() => {
                    this.$refs.inputEl.focus();
                });
            }
        }
    }
}
</script>

<style scoped>
.custom-searchbar {
    --background: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.07);
    --box-shadow: none;
    --cancel-button-color: var(--ion-color-primary, #3880ff);
    --clear-button-color: var(--ion-color-step-600, #666666);
    --color: var(--ion-text-color, #000);
    --icon-color: var(--ion-color-step-600, #666666);

    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    min-height: 42px;
    border-radius: 8px;
    background: var(--background);
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-searchbar.has-focus {
    --background: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.09);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.searchbar-input-container {
    display: flex;
    position: relative;
    flex: 1;
    flex-direction: row;
    align-items: center;
}

.searchbar-search-icon,
.searchbar-clear-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;
    fill: var(--icon-color);
}

.searchbar-search-icon {
    margin-left: 8px;
}

.searchbar-search-icon svg,
.searchbar-clear-icon svg {
    width: 20px;
    height: 20px;
}

.searchbar-clear-icon {
    cursor: pointer;
}

.searchbar-input {
    padding: 8px;
    width: 100%;
    border: none;
    background: transparent;
    color: var(--color);
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    font-style: inherit;
    letter-spacing: inherit;
    text-decoration: inherit;
    text-indent: inherit;
    text-overflow: inherit;
    text-transform: inherit;
    text-align: inherit;
    white-space: inherit;
    appearance: none;
    outline: none;
}

.searchbar-input::placeholder {
    color: var(--ion-color-step-400, #999);
    opacity: 1;
}

/* iOS specific styles */
.custom-searchbar[mode="ios"] {
    padding: 0 8px;
    border-radius: 10px;
    height: 36px;
    background: rgba(var(--ion-text-color-rgb, 0, 0, 0), 0.07);
}

.custom-searchbar[mode="ios"] .searchbar-input {
    height: 36px;
    font-size: 14px;
}

/* Position styles */
.custom-searchbar[position="start"] {
    margin-left: 0;
    margin-right: auto;
}

.custom-searchbar[position="end"] {
    margin-left: auto;
    margin-right: 0;
}

.custom-searchbar[position="center"] {
    margin-left: auto;
    margin-right: auto;
}

/* Optional: you can add a specific class to remove padding */
.no-search-padding {
    padding: 0;
}
</style>
